/* eslint-disable */

// This serves as a nasty and dirty solution to enable React to emit Angular $rootScope event emiting,
// which Angular side of Sling app relies heavily on. It aims to address the problem of passing the
// hand-crafted props from Angular realm to React components. Eventually, when we rebuild things around
// refreshing React app state on different events, this can then be removed.

let $rootScope;

export const accessAngularRootScope = () => {
  if (!$rootScope && 'angular' in window) {
    $rootScope = (window as any).angular.element(document.body).injector().get('$rootScope');
  }

  const ngEmit = (subject: string, data: any) => $rootScope.$emit(subject, data);

  return { ngEmit };
};
